import { createFileRoute } from '@tanstack/react-router';

import { CreateLookbookPage } from '@/features/lookbooks/CreateLookbookPage';

/*
  Its own route rather than a mode on the record, the same reason products/new is: a half-made
  lookbook has no id to be at. The static path sits before $lookbookId in the generated tree, so
  "new" is never read as an id.
*/
export const Route = createFileRoute('/_app/lookbooks/new')({
    component: CreateLookbookPage,
});
